import React, { useContext, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Tabs,
  Tab,
  IconButton,
  Menu,
  Avatar,
  MenuItem,
  Divider,
  Dialog,
  Button,
  Chip,
  Badge,
  Drawer,
  List,
  ListItem,
  useMediaQuery,
} from "@mui/material";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonIcon from "@mui/icons-material/Person";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import PaymentRoundedIcon from "@mui/icons-material/PaymentRounded";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import { ColorModeContext } from "../App";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import ComingSoon from "../Utils/ComingSoon";
import { useSelector, useDispatch } from "react-redux";
import { clearUser } from "../Slice/authSlice";
import { WalletFocusContext } from "./WalletFocusContext";
import api from "../Utils/Api";
import { date, entity_id, Platform } from "../Utils/Const";
import { baseapi } from "../Environmentalurl";

const NAV = [
  { label: "Home", icon: HomeRoundedIcon },
  { label: "Bill Pay", icon: PaymentRoundedIcon },
  { label: "Expense", icon: AccountBalanceWalletIcon },
  { label: "Gift Card", icon: CardGiftcardIcon },
  { label: "RuPay", icon: CreditCardIcon },
  { label: "Grievance", icon: GavelRoundedIcon },
];

export default function DashboardHeader({ billPaymentRef, walletRef }) {
  const [openKycPopup, setOpenKycPopup] = useState(false);
  const kycstatus = sessionStorage.getItem("Is_KYC_Done") || "2";
  const rupayRefNo = useSelector((state) => state.auth.rupayRefNo);
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openDrawer, setOpenDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [giftTypes, setGiftTypes] = useState([]);
  const [occasions, setOccasions] = useState([]);
  const [selectedGiftType] = useState("DIGITALVOUCHER");
  const [providerKey, setProviderKey] = useState(null);
  const open = Boolean(anchorEl);
  const [value, setValue] = useState(0);
  const location = useLocation();
  const [openComingSoon, setOpenComingSoon] = useState(false);
  const { setHighlightWallet } = useContext(WalletFocusContext);
  const user = useSelector((state) => state.auth.user);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (location.pathname.includes("/bbps")) setValue(1);
    else if (location.pathname.includes("/giftcard")) setValue(3);
    else if (
      location.pathname.includes("/rupaycard") ||
      location.pathname.includes("/wallet")
    )
      setValue(4);
    else if (location.pathname.includes("/grievance")) setValue(5);
    else if (location.pathname === "/dashboard") setValue(0);
    else setValue(false);
  }, [location.pathname]);

  const getCurrentDateTime = () => {
    const now = date;
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const hh = String(now.getHours()).padStart(2, "0");
    const min = String(now.getMinutes()).padStart(2, "0");
    const ss = String(now.getSeconds()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate("/dashboard");
        break;
      case 1:
        navigate("/dashboard/bbps/DTH");
        break;
      case 2:
        setOpenComingSoon(true);
        break;
      case 3:
        navigate("/dashboard/giftcard");
        break;
      case 4:
        if (kycstatus === "2") {
          setOpenKycPopup(true);
          return;
        }
        if (kycstatus === "1" && rupayRefNo) {
          navigate("/dashboard/rupaycard", { replace: true });
          return;
        }
        if (kycstatus === "1" && !rupayRefNo) {
          navigate("/dashboard/wallet/rupayonboarding", { replace: true });
          return;
        }
        break;
      case 5:
        navigate("/dashboard/grievance", { state: { focusWallet: true } });
        break;
      default:
        break;
    }
  };

  // ---- FIXED LOGOUT ----
  // 1. Preserves SessionWalletToken in localStorage — the SAME storage
  //    that Loginpage.js and OtpPage.js actually read it from. The
  //    previous version saved it into sessionStorage, which Loginpage/
  //    OtpPage never check — so after logout, the token they'd find in
  //    localStorage was whatever was already there (often stale), not
  //    the one this function intended to preserve.
  // 2. Uses a hard redirect (window.location.href) instead of
  //    navigate() + window.location.reload(), since calling both
  //    together races the SPA router and can leave the app on the
  //    wrong route (e.g. /verify-otp) right as it reloads.
  const handleLogout = () => {
    const walletToken = localStorage.getItem("SessionWalletToken");

    dispatch(clearUser());
    sessionStorage.clear();
    localStorage.clear();

    if (walletToken !== null) {
      localStorage.setItem("SessionWalletToken", walletToken);
    }

    window.location.href = "/";
  };

  useEffect(() => {
    const fetchGiftCards = async () => {
      try {
        const payload = {
          ReqType: "MT_Gift_Instrument",
          Statement_Type: "TARupayGiftVouchers",
          Mobilenumber: sessionStorage.getItem("mobileNumber"),
          Platform: Platform,
          MachineID: "::1",
          GeoLocation: "12.9786,77.364",
          SessionID: sessionStorage.getItem("SessionID"),
          EntityID: entity_id,
          Date: getCurrentDateTime(),
        };
        const response = await api.post(
          `${baseapi}/giftinstrument`,
          payload,
        );
        if (response.data?.Response_Code === "1000") {
          const info = response.data.Info || [];
          setGiftTypes(info);
          const dv = info.find((i) => i.service_type === "DIGITALVOUCHER");
          if (dv) {
            setProviderKey(dv.provider_key);
            setOccasions(JSON.parse(dv.EventList));
          }
        }
      } catch { }
    };
    fetchGiftCards();
  }, []);

  const initial = user?.NameOnCard?.charAt(0)?.toUpperCase() || "U";
  const firstName = user?.NameOnCard?.split(" ")[0] || "Account";

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          top: 0,
          zIndex: 1200,
          bgcolor: "white",
          borderBottom: "1px solid #f1f5f9",
          boxShadow: scrolled ? "0 2px 20px rgba(0,0,0,0.06)" : "none",
          transition: "box-shadow 0.2s",
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            px: { xs: 2, md: 4 },
            minHeight: { xs: 58, md: 64 },
          }}
        >
          {/* Mobile menu */}
          {isMobile && (
            <IconButton
              onClick={() => setOpenDrawer(true)}
              sx={{ color: "#475569", mr: 1 }}
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Logo */}
          <Box
            onClick={() => navigate("/dashboard")}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.2,
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                width: { xs: 34, md: 38 },
                height: { xs: 34, md: 38 },
                borderRadius: "10px",
                background: "linear-gradient(135deg, #15803d 0%, #22c55e 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 12px rgba(22,163,74,0.3)",
              }}
            >
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "12px",
                  bgcolor: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                }}
              >
                <Box
                  component="img"
                  src="/Assets/ta_walletlogo.png"
                  alt="TA Wallet"
                  sx={{
                    width: 34,
                    height: 34,
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Box>
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 800,
                  color: "#16a34a",
                  lineHeight: 1,
                  letterSpacing: "-0.2px",
                }}
              >
                ONE
              </Typography>
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 800,
                  color: "#16a34a",
                  lineHeight: 1,
                }}
              >
                APP
              </Typography>
            </Box>
          </Box>

          {/* Desktop nav tabs */}
          {!isMobile && (
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                sx={{
                  "& .MuiTabs-indicator": {
                    bgcolor: "#16a34a",
                    height: 2.5,
                    borderRadius: "2px 2px 0 0",
                  },
                  "& .MuiTab-root": {
                    fontSize: 13,
                    fontWeight: 500,
                    textTransform: "none",
                    color: "#64748b",
                    minHeight: 64,
                    px: 1.5,
                    minWidth: 0,
                    "&.Mui-selected": {
                      color: "#16a34a",
                      fontWeight: 700,
                    },
                  },
                }}
              >
                {NAV.map((n) => (
                  <Tab key={n.label} label={n.label} />
                ))}
              </Tabs>
            </Box>
          )}

          {/* Right actions */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton
              sx={{
                color: "#64748b",
                width: 36,
                height: 36,
                bgcolor: "#f8fafc",
                border: "1px solid #f1f5f9",
                "&:hover": { bgcolor: "#f0fdf4", color: "#16a34a" },
              }}
            >
              <Badge badgeContent={0} color="error">
                <NotificationsNoneIcon sx={{ fontSize: 18 }} />
              </Badge>
            </IconButton>

            {/* Avatar button */}
            <Box
              onClick={(e) => setAnchorEl(e.currentTarget)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                bgcolor: "#f8fafc",
                border: "1.5px solid #e2e8f0",
                borderRadius: "40px",
                pl: 0.5,
                pr: { xs: 0.5, md: 1.5 },
                py: 0.4,
                cursor: "pointer",
                transition: "all 0.2s",
                "&:hover": { bgcolor: "#f0fdf4", borderColor: "#86efac" },
              }}
            >
              <Avatar
                sx={{
                  width: { xs: 28, md: 32 },
                  height: { xs: 28, md: 32 },
                  fontSize: { xs: 12, md: 13 },
                  fontWeight: 800,
                  background: "linear-gradient(135deg, #16a34a, #22c55e)",
                  boxShadow: "0 2px 8px rgba(22,163,74,0.25)",
                }}
              >
                {initial}
              </Avatar>
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#0f172a",
                  display: { xs: "none", md: "block" },
                }}
              >
                {firstName}
              </Typography>
              <KeyboardArrowDownIcon
                sx={{
                  fontSize: 16,
                  color: "#94a3b8",
                  display: { xs: "none", md: "block" },
                }}
              />
            </Box>

            {/* Dropdown */}
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)}
              PaperProps={{
                elevation: 0,
                sx: {
                  mt: 1.5,
                  borderRadius: "16px",
                  width: 260,
                  overflow: "visible",
                  border: "1px solid #f1f5f9",
                  boxShadow: "0 12px 40px rgba(0,0,0,0.10)",
                  "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: -6,
                    right: 16,
                    width: 12,
                    height: 12,
                    bgcolor: "white",
                    transform: "rotate(45deg)",
                    borderLeft: "1px solid #f1f5f9",
                    borderTop: "1px solid #f1f5f9",
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <Box sx={{ px: 2, pt: 2, pb: 1.5 }}>
                <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                  <Avatar
                    sx={{
                      width: 44,
                      height: 44,
                      fontSize: 17,
                      fontWeight: 800,
                      background: "linear-gradient(135deg, #16a34a, #22c55e)",
                    }}
                  >
                    {initial}
                  </Avatar>
                  <Box>
                    <Typography
                      sx={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}
                    >
                      {user?.NameOnCard || "User"}
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>
                      {user?.Poiemail || sessionStorage.getItem("mobileNumber")}
                    </Typography>
                    <Chip
                      label={kycstatus === "1" ? "Full KYC ✓" : "Low KYC"}
                      size="small"
                      sx={{
                        height: 18,
                        fontSize: 9,
                        fontWeight: 700,
                        mt: 0.5,
                        bgcolor: kycstatus === "1" ? "#dcfce7" : "#fef9c3",
                        color: kycstatus === "1" ? "#15803d" : "#854d0e",
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Divider sx={{ borderColor: "#f8fafc" }} />
              {[
                {
                  icon: <PersonIcon sx={{ fontSize: 17 }} />,
                  label: "My Profile",
                  action: () => {
                    navigate("/profile-settings");
                    setAnchorEl(null);
                  },
                },
                {
                  icon: <HelpOutlineIcon sx={{ fontSize: 17 }} />,
                  label: "Help Center",
                  action: () => {
                    navigate("/helpcenterlayout");
                    setAnchorEl(null);
                  },
                },
              ].map((item) => (
                <MenuItem
                  key={item.label}
                  onClick={item.action}
                  sx={{
                    px: 2,
                    py: 1.2,
                    gap: 1.5,
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#374151",
                    "&:hover": { bgcolor: "#f0fdf4", color: "#16a34a" },
                  }}
                >
                  {item.icon} {item.label}
                </MenuItem>
              ))}
              <Divider sx={{ borderColor: "#f8fafc", my: 0.5 }} />
              <MenuItem
                onClick={handleLogout}
                sx={{
                  px: 2,
                  py: 1.2,
                  gap: 1.5,
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#ef4444",
                  "&:hover": { bgcolor: "#fff1f2" },
                }}
              >
                <LogoutIcon sx={{ fontSize: 17 }} /> Sign Out
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile drawer */}
      <Drawer
        anchor="left"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        PaperProps={{ sx: { width: 260, bgcolor: "white" } }}
      >
        <Box
          sx={{
            p: 2.5,
            borderBottom: "1px solid #f1f5f9",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontWeight: 800, fontSize: 16, color: "#0f172a" }}>
            Menu
          </Typography>
          <IconButton onClick={() => setOpenDrawer(false)} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <List sx={{ p: 1.5 }}>
          {NAV.map((n, idx) => (
            <ListItem
              button
              key={n.label}
              onClick={() => {
                handleChange(null, idx);
                setOpenDrawer(false);
              }}
              sx={{
                borderRadius: "10px",
                mb: 0.5,
                px: 2,
                py: 1.2,
                color: value === idx ? "#16a34a" : "#374151",
                bgcolor: value === idx ? "#f0fdf4" : "transparent",
                gap: 1.5,
              }}
            >
              <n.icon sx={{ fontSize: 18 }} />
              <Typography
                sx={{ fontWeight: value === idx ? 700 : 500, fontSize: 14 }}
              >
                {n.label}
              </Typography>
            </ListItem>
          ))}
        </List>
      </Drawer>

      <ComingSoon
        open={openComingSoon}
        onClose={() => setOpenComingSoon(false)}
      />

      {/* KYC Dialog */}
      <Dialog
        open={openKycPopup}
        onClose={() => setOpenKycPopup(false)}
        PaperProps={{
          sx: { borderRadius: "20px", overflow: "hidden", width: 360 },
        }}
      >
        <Box
          sx={{
            background: "linear-gradient(135deg, #15803d, #22c55e)",
            p: 3.5,
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              bgcolor: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 2,
            }}
          >
            <CreditCardIcon sx={{ fontSize: 30, color: "white" }} />
          </Box>
          <Typography sx={{ fontWeight: 800, fontSize: 18, color: "white" }}>
            KYC Required
          </Typography>
          <Typography
            sx={{ fontSize: 13, color: "rgba(255,255,255,0.8)", mt: 0.5 }}
          >
            Upgrade to access RuPay Card
          </Typography>
        </Box>
        <Box sx={{ p: 3 }}>
          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              textAlign: "center",
              mb: 3,
              lineHeight: 1.7,
            }}
          >
            Complete your Full KYC verification to unlock RuPay Card and enjoy
            higher transaction limits.
          </Typography>
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => setOpenKycPopup(false)}
              sx={{
                borderColor: "#e2e8f0",
                color: "#374151",
                borderRadius: "10px",
              }}
            >
              Later
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                setOpenKycPopup(false);
                navigate("/profile-settings");
              }}
              sx={{
                background: "linear-gradient(135deg, #16a34a, #22c55e)",
                borderRadius: "10px",
              }}
            >
              Upgrade Now
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}
